/* DELLUMIA home DE LUXE header. Cart state only; BOGOS still applies offers.
   Threshold values are theme settings and must be kept aligned with BOGOS. */
(() => {
  'use strict';
  if (window.__dellumiaHomeProgressInstalled) return;
  window.__dellumiaHomeProgressInstalled = true;
  const selector = '[data-dellumia-home-progress]';
  const nodes = new WeakMap();
  const cartWritePath = /\/cart\/(?:add|change|update|clear)(?:\.js)?(?:\?|$)/i;
  let scheduled = 0;
  let requestId = 0;
  let observedSection = null;
  let headerResizeObserver = null;
  const newYorkPartsFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York', year: 'numeric', month: '2-digit',
    day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit',
    hourCycle: 'h23'
  });

  function nyParts(milliseconds) {
    const parts = Object.create(null);
    for (const p of newYorkPartsFormatter.formatToParts(new Date(milliseconds))) {
      if (p.type !== 'literal') parts[p.type] = Number(p.value);
    }
    return parts;
  }

  // Solve the next local midnight in New York, adjusting for daylight saving time.
  function nextNyMidnight(nowMs) {
    const p = nyParts(nowMs);
    const next = new Date(Date.UTC(p.year, p.month - 1, p.day + 1));
    const target = Date.UTC(next.getUTCFullYear(), next.getUTCMonth(), next.getUTCDate());
    let guess = target + 5 * 60 * 60 * 1000;
    for (let i = 0; i < 3; i += 1) {
      const q = nyParts(guess);
      const shown = Date.UTC(q.year, q.month - 1, q.day, q.hour, q.minute, q.second);
      guess += target - shown;
    }
    return guess;
  }

  function clockTextAt(nowMs) {
    const remainingSeconds = Math.max(0, Math.ceil((nextNyMidnight(nowMs) - nowMs) / 1000));
    const hours = Math.floor(remainingSeconds / 3600);
    const minutes = Math.floor((remainingSeconds % 3600) / 60);
    const seconds = remainingSeconds % 60;
    return `${String(hours).padStart(2, '0')}h : ${String(minutes).padStart(2, '0')}m : ${String(seconds).padStart(2, '0')}s`;
  }

  function updateCountdown() {
    const value = clockTextAt(Date.now());
    for (const el of document.querySelectorAll('[data-dlh-clock]')) {
      if (el.textContent !== value) el.textContent = value;
    }
  }


  function bars() { return Array.from(document.querySelectorAll(selector)); }
  function rootUrl(bar) {
    const path = bar.dataset.cartRoot || '/';
    return path.endsWith('/') ? path : `${path}/`;
  }
  function getThresholds(bar) {
    return [1, 2, 3, 4].map(i => Number(bar.getAttribute(`data-goal-${i}`)) || 0);
  }
  function getSubtotal(cart, bar) {
    // Original unit/line price is pre-discount. Explicitly exclude a configured
    // free-gift handle, or a fully discounted free item (to prevent self-qualification).
    const giftHandle = (bar.dataset.giftHandle || '').trim().toLowerCase();
    if (!Array.isArray(cart.items)) return Math.max(0, Number(cart.original_total_price) || 0);
    return cart.items.reduce((sum, item) => {
      const handle = String(item.handle || '').toLowerCase();
      const original = Number(item.original_line_price) || 0;
      const final = Number(item.final_line_price);
      const isGift = (giftHandle && handle === giftHandle) ||
        (original > 0 && final === 0);
      return sum + (isGift ? 0 : original);
    }, 0);
  }
  function paint(bar, cents) {
    const thresholds = getThresholds(bar);
    const status = bar.querySelector('[data-dlh-status]');
    let highest = 0;
    for (let i = 1; i <= 4; i += 1) {
      const reached = thresholds[i - 1] > 0 && cents >= Math.round(thresholds[i - 1] * 100);
      const tier = bar.querySelector(`[data-dlh-goal="${i}"]`);
      if (tier) tier.classList.toggle('is-active', reached);
      if (reached) highest = i;
    }
    bar.setAttribute('aria-busy', 'false');
    const old = nodes.get(bar);
    if (status && old !== highest) {
      status.textContent = highest === 4 ? 'FREE Mystery Gift milestone reached' :
        highest ? `Savings milestone ${highest} reached` : 'No savings milestone reached yet';
    }
    nodes.set(bar, highest);
  }
  async function refresh() {
    const elements = bars();
    if (!elements.length) return;
    const id = ++requestId;
    try {
      const res = await fetch(`${rootUrl(elements[0])}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
      if (!res.ok) throw new Error('Cart request failed');
      const cart = await res.json();
      if (id !== requestId) return;
      for (const bar of elements) paint(bar, getSubtotal(cart, bar));
    } catch (err) {
      // Fail closed: do not claim a reached tier on a failed cart request.
      for (const bar of elements) {
        bar.setAttribute('aria-busy', 'true');
        const status = bar.querySelector('[data-dlh-status]');
        if (status) status.textContent = 'Savings status temporarily unavailable';
      }
    }
  }
  function schedule(wait = 130) {
    clearTimeout(scheduled);
    scheduled = setTimeout(refresh, wait);
  }
  function afterWrite() {
    schedule(150);
    setTimeout(() => schedule(0), 700); // allow delayed BOGOS free-gift cart mutation
  }
  // Measure the INNER bar, not the collapsing Shopify section.
  // Observing the section itself would feed the animated height back into its
  // own CSS variable and cause snapping/flicker during the transition.
  function setupHeaderHeightObserver() {
    const announcement = document.querySelector('.announcement-bar-section:has([data-dellumia-home-progress])');
    if (announcement === observedSection) return;
    if (headerResizeObserver) headerResizeObserver.disconnect();
    observedSection = announcement;
    if (!announcement) return;
    const content = announcement.querySelector(selector);
    if (!content) return;
    const syncHeight = () => {
      // The content keeps its intrinsic height when its parent collapses.
      const measured = Math.ceil(content.getBoundingClientRect().height);
      if (measured > 0) {
        document.documentElement.style.setProperty('--dellumia-home-announcement-height', `${measured + 2}px`);
      }
    };
    syncHeight();
    if (typeof ResizeObserver !== 'undefined') {
      headerResizeObserver = new ResizeObserver(syncHeight);
      headerResizeObserver.observe(content);
    }
  }

  // Sitewide popup mirrors the product-page HTML, CSS and interaction patterns.
  let popupState = null;
  function modalFor(bar) {
    return bar?.querySelector('[data-dlh-modal]') || null;
  }
  function redrawModal(bar) {
    const modal = modalFor(bar);
    if (!modal) return;
    const amounts = getThresholds(bar);
    for (let i = 1; i <= 4; i += 1) {
      const tier = bar.querySelector(`[data-dlh-goal="${i}"]`);
      const benefit = tier?.querySelector('.dellumia-home-progress__label strong')?.textContent?.trim() || '';
      const item = modal.querySelector(`[data-dlh-popup-goal="${i}"]`);
      const thresholdNode = item?.querySelector('[data-dlh-popup-threshold]');
      const benefitNode = item?.querySelector('[data-dlh-popup-benefit]');
      if (thresholdNode) thresholdNode.textContent = `Spend $${amounts[i - 1]}${i >= 3 ? '+' : ''}`;
      if (benefitNode) benefitNode.textContent = i === 4 ? `unlock a ${benefit}` :
        `Save ${benefit.replace(/\s*off$/i, '').trim()}`;
    }
  }
  function redrawAllModals() { for (const bar of bars()) redrawModal(bar); }
  function closePopup(restoreFocus = true) {
    if (!popupState) return;
    const { bar, modal, trigger } = popupState;
    modal.hidden = true;
    if (modal.parentNode === document.body) {
      if (bar.isConnected) bar.appendChild(modal);
      else modal.remove();
    }
    popupState = null;
    document.body.classList.remove('dellumia-bogos-modal-open');
    if (restoreFocus && trigger?.isConnected) trigger.focus({ preventScroll: true });
  }
  function openPopup(bar, trigger) {
    if (popupState) closePopup(false);
    redrawModal(bar);
    const modal = modalFor(bar);
    if (!modal) return;
    // Header and product sections may be transformed/contained. Portal to body.
    modal.style.fontFamily = getComputedStyle(bar).fontFamily;
    document.body.appendChild(modal);
    modal.hidden = false;
    popupState = { bar, trigger, modal };
    document.body.classList.add('dellumia-bogos-modal-open');
    requestAnimationFrame(() => modal.querySelector('[role="dialog"]')?.focus({ preventScroll: true }));
  }
  function onDocumentClick(event) {
    const trigger = event.target.closest('[data-dlh-open-modal]');
    if (trigger) {
      const bar = trigger.closest(selector);
      if (bar) { event.preventDefault(); openPopup(bar, trigger); return; }
    }
    if (popupState && event.target.closest('[data-dlh-close-modal]') && popupState.modal.contains(event.target)) {
      event.preventDefault(); closePopup();
    }
  }
  function onDocumentKeydown(event) {
    if (!popupState) return;
    if (event.key === 'Escape') { event.preventDefault(); closePopup(); return; }
    if (event.key !== 'Tab') return;
    const dialog = popupState.modal.querySelector('[role="dialog"]');
    const els = Array.from(dialog.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])'))
      .filter(el => !el.hidden && getComputedStyle(el).visibility !== 'hidden');
    if (!els.length) {event.preventDefault();dialog.focus();return;}
    const first=els[0],last=els[els.length-1];
    if(event.shiftKey && (document.activeElement===first || document.activeElement===dialog)) {
      event.preventDefault();last.focus();
    } else if(!event.shiftKey && (document.activeElement===last || document.activeElement===dialog)) {
      event.preventDefault();first.focus();
    }
  }

  // Product: main product gallery. Collection: first visible product image.
  // Scroll minimum is independently customizable for product and collection.
  let lastStickyKey = null;
  let thresholdCache = null;
  function updateSticky() {
    const bar = bars()[0];
    const shell = document.querySelector('.transparent_header:has([data-dellumia-home-progress])');
    if (!bar || !shell) return;
    const page = document.body;
    let pageType = null, anchor = null, enabled = false, minScroll = 0;
    if (page.classList.contains('page-product')) {
      pageType = 'product';
      enabled = bar.dataset.hideOnProduct === 'true';
      minScroll = Number(bar.dataset.productMinScroll) || 0;
      anchor = document.querySelector('main .product__media-wrapper');
    } else if (page.classList.contains('page-collection')) {
      pageType = 'collection';
      enabled = bar.dataset.hideOnCollection === 'true';
      minScroll = Number(bar.dataset.collectionMinScroll) || 0;
      anchor = document.querySelector('#product-grid .card__media, #ProductGridContainer #product-grid, #ProductGridContainer');
    }
    if (!enabled || !anchor) {
      shell.classList.remove('dellumia-promo-past-images');
      lastStickyKey = 'show';
      thresholdCache = null;
      return;
    }
    // Cache the document position before hiding the announcement. Otherwise
    // collapsing its height moves the photos and causes an on/off scroll loop.
    if (!thresholdCache || thresholdCache.pageType !== pageType || thresholdCache.anchor !== anchor) {
      const header = shell.querySelector('.section-header');
      const headerHeight = header ? header.getBoundingClientRect().height : 0;
      const anchorY = anchor.getBoundingClientRect().top + window.scrollY;
      thresholdCache = {pageType, anchor, threshold: Math.max(minScroll, anchorY - headerHeight)};
    }
    const threshold = thresholdCache.threshold;
    // Small hysteresis prevents repeated opening/closing near the boundary.
    // The cached threshold is intentionally independent of the bar's
    // animated height, so the scroll target cannot chase a moving header.
    const alreadyHidden = shell.classList.contains('dellumia-promo-past-images');
    // Browser scroll anchoring can move scrollY backwards by the promo's
    // full height while it collapses. Account for that height before
    // reopening, otherwise the bar oscillates at the gallery boundary.
    const revealAt = Math.max(0, threshold - Math.ceil(bar.getBoundingClientRect().height) - 20);
    const hidden = alreadyHidden
      ? window.scrollY > 0 && window.scrollY >= revealAt
      : window.scrollY >= threshold;
    const nextKey = `${pageType}:${hidden}`;
    if (nextKey !== lastStickyKey) {
      shell.classList.toggle('dellumia-promo-past-images', hidden);
      const openButton = bar.querySelector('[data-dlh-open-modal]');
      if (openButton) openButton.tabIndex = hidden ? -1 : 0;
      lastStickyKey = nextKey;
    }
  }
  let scrollFrame = 0;
  function scheduleSticky() {
    if (scrollFrame) return;
    scrollFrame = requestAnimationFrame(() => {
      scrollFrame = 0;
      updateSticky();
    });
  }

  function init() {
    if (!bars().length) return;
    setupHeaderHeightObserver();
    // Avoid a flash/slide on first paint if the page opens mid-scroll.
    const stickyShell = document.querySelector('.transparent_header:has([data-dellumia-home-progress])');
    if (stickyShell) stickyShell.classList.add('dellumia-promo-no-initial-transition');
    updateSticky();
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (stickyShell) stickyShell.classList.remove('dellumia-promo-no-initial-transition');
    }));
    updateCountdown();
    refresh();
    redrawAllModals();
    if (!window.__dellumiaHomeBarFetchWrapped && typeof window.fetch === 'function') {
      const originalFetch = window.fetch;
      window.fetch = function (...args) {
        const url = args[0] instanceof Request ? args[0].url : String(args[0] || '');
        const isMutation = cartWritePath.test(url);
        return originalFetch.apply(this, args).then(res => {
          if (isMutation && res.ok) afterWrite();
          return res;
        });
      };
      window.__dellumiaHomeBarFetchWrapped = true;
    }
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => schedule(80));
    }
    for (const name of ['cart:updated','cart:refresh','cart:change','cart:updated:drawer']) {
      document.addEventListener(name, () => schedule(80));
    }
    document.addEventListener('shopify:section:load', () => {
      if (popupState && !popupState.bar.isConnected) closePopup(false);
      thresholdCache = null; setupHeaderHeightObserver(); updateCountdown(); redrawAllModals(); schedule(70); scheduleSticky();
    });
    document.addEventListener('shopify:section:unload', () => {
      if (popupState && !popupState.bar.isConnected) closePopup(false);
    });
    document.addEventListener('click', onDocumentClick);
    document.addEventListener('keydown', onDocumentKeydown);
    window.addEventListener('scroll', scheduleSticky, {passive:true});
    let lastViewportWidth = window.innerWidth;
    window.addEventListener('resize', () => {
      if (window.innerWidth !== lastViewportWidth) { thresholdCache = null; lastViewportWidth = window.innerWidth; }
      scheduleSticky();
    }, {passive:true});
    window.addEventListener('pageshow', () => schedule(50));
    document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(70); });
    window.addEventListener('focus', () => schedule(70));
    window.setInterval(() => { if (!document.hidden && bars().length) updateCountdown(); }, 1000);
    // Catch cart changes made by third-party code that doesn't announce events.
    window.setInterval(() => { if (!document.hidden && bars().length) refresh(); }, 5000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
